<div
  class="bg-additional d-flex align-items-center"
  [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl + ')' }"
></div>
<div class="container d-flex align-items-center py-4">
  <a href="/" class="d-flex align-items-center">
    <img
      src="https://res.cloudinary.com/pervolare-org/image/upload/v1731004189/spv/sites/images/suppliers/icon-home_z62m6d.png"
      alt="icon home"
      width="44"
      height="20"
    />
  </a>
  <p class="mb-0 Gotham-bold f-12">{{ 'PAGES.Additional.Servicios Adicionales' | translate }}</p>
</div>
<div class="container mb-4">
  <p class="Gotham-medium f-24 f-lg-28 text-center text-md-left">
    {{ 'PAGES.Additional.Descubre Nuestros Adicionales' | translate }}
  </p>
  <p class="Gotham-book f-14 f-lg-18 text-justify text-md-left">
    {{ 'PAGES.Additional.Descripcion adicionales' | translate }}
  </p>
  <p class="Gotham-medium f-15 f-lg-18 mt-5">
    {{ 'PAGES.Additional.¿Dudas sobre qué adicional necesitas para tu viaje? Conócelos aquí' | translate }}
  </p>
</div>
<div class="container" id="additional">
  <nav ngbNav #nav="ngbNav" class="nav-tabs">
    <ng-container ngbNavItem>
      <a ngbNavLink class="mr-2 mr-md-5 text-dark"
        ><p class="mb-0 Gotham-book f-14 f-lg-15">{{ 'PAGES.Additional.Vuelo' | translate }}</p></a
      >
      <ng-template ngbNavContent>
        <ngb-accordion [closeOthers]="true" #acc="ngbAccordion">
          <ngb-panel
            *ngFor="let item of 'PAGES.Additional.vuelo_items' | translate; let i = index"
            [id]="'ngb-panel-' + (i + 1)"
            cardClass="{{ acc.isExpanded('ngb-panel-' + (i + 1)) ? 'card-content' : '' }}"
            class="mb-4"
          >
            <ng-template ngbPanelHeader>
              <div class="d-flex align-items-center justify-content-between">
                <button ngbPanelToggle class="btn btn-link container-fluid text-left pl-0 py-0">
                  <div class="d-inline-flex align-items-center w-sumary">
                    <img [src]="item.img" [alt]="item.title" class="icon-additional" />
                    <div class="ml-2">
                      <p class="mb-0 Gotham-medium f-14 f-lg-20 text-dark">{{ item.title }}</p>
                      <p class="mb-0 Gotham-book f-12 f-lg-16 text-dark">{{ item.sumary }}</p>
                    </div>
                  </div>
                  <div class="float-right">
                    <img
                      *ngIf="acc.isExpanded('ngb-panel-' + (i + 1))"
                      class="mt-md-4"
                      src="https://res.cloudinary.com/pervolare-org/image/upload/v1731539465/spv/sites/images/Additional/arrow-close_rg45r0.svg"
                      alt="icon-arrow-close"
                    />

                    <img
                      *ngIf="!acc.isExpanded('ngb-panel-' + (i + 1))"
                      class="mt-md-4"
                      src="https://res.cloudinary.com/pervolare-org/image/upload/v1731539465/spv/sites/images/Additional/arrow_xmr3ua.svg"
                      alt="icon-arrow"
                    />
                  </div>
                </button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <p class="Gotham-book f-12 f-lg-16 mb-0">{{ item.description }}</p>
              <div class="text-center">
                <a
                  class="text-white btn btn-additional mt-3 text-white Gotham-medium f-15 py-1"
                  [href]="'PAGES.Additional.link_additional' | translate : { phone, name: item.title }"
                  target="_blank"
                  >{{ 'PAGES.Additional.¡Adquiérelo ya!' | translate }}</a
                >
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </ng-template>
    </ng-container>

    <ng-container ngbNavItem>
      <a ngbNavLink class="mr-2 mr-md-5 text-dark"
        ><p class="mb-0 Gotham-book f-14 f-lg-15">{{ 'PAGES.Additional.Otros' | translate }}</p></a
      >
      <ng-template ngbNavContent>
        <ngb-accordion [closeOthers]="true" #acc="ngbAccordion">
          <ngb-panel
            *ngFor="let item of 'PAGES.Additional.otros_items' | translate; let i = index"
            [id]="'ngb-panel-' + (i + 1)"
            cardClass="{{ acc.isExpanded('ngb-panel-' + (i + 1)) ? 'card-content' : '' }}"
            class="mb-4"
          >
            <ng-template ngbPanelHeader>
              <div class="d-flex align-items-center justify-content-between">
                <button ngbPanelToggle class="btn btn-link container-fluid text-left pl-0 py-0">
                  <div class="d-inline-flex align-items-center w-sumary">
                    <img [src]="item.img" [alt]="item.title" class="icon-additional" />
                    <div class="ml-2">
                      <p class="mb-0 Gotham-medium f-14 f-lg-20 text-dark">{{ item.title }}</p>
                      <p class="mb-0 Gotham-book f-12 f-lg-16 text-dark">{{ item.sumary }}</p>
                    </div>
                  </div>
                  <div class="float-right">
                    <img
                      *ngIf="acc.isExpanded('ngb-panel-' + (i + 1))"
                      class="mt-md-4"
                      src="https://res.cloudinary.com/pervolare-org/image/upload/v1731539465/spv/sites/images/Additional/arrow-close_rg45r0.svg"
                      alt="icon-arrow-close"
                    />

                    <img
                      *ngIf="!acc.isExpanded('ngb-panel-' + (i + 1))"
                      class="mt-md-4"
                      src="https://res.cloudinary.com/pervolare-org/image/upload/v1731539465/spv/sites/images/Additional/arrow_xmr3ua.svg"
                      alt="icon-arrow"
                    />
                  </div>
                </button>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <p class="Gotham-book f-12 f-lg-16 mb-0" [innerHTML]="item.description"></p>
              <div class="text-center">
                <a
                  class="text-white btn btn-additional mt-3 text-white Gotham-medium f-15 py-1"
                  [href]="'PAGES.Additional.link_additional' | translate : { phone, name: item.title }"
                  target="_blank"
                  >{{ 'PAGES.Additional.¡Adquiérelo ya!' | translate }}</a
                >
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </ng-template>
    </ng-container>
  </nav>

  <div [ngbNavOutlet]="nav" class="mt-4"></div>
</div>

<div class="mt-5 pt-4" style="background: #f8f8f8">
  <div class="container" id="situations">
    <p class="text-center Gotham-medium f-20 f-lg-28 mb-0">
      {{ 'PAGES.Additional.Situaciones comunes entre nuestros viajeros' | translate }}
    </p>
    <p class="text-center Gotham-book f-14 f-lg-18 mb-5">
      {{ 'PAGES.Additional.Descubre cómo nuestros adicionales pueden salvarte y resuelve tus dudas' | translate }}
    </p>

    <ngb-accordion [closeOthers]="true" #acc="ngbAccordion">
      <ngb-panel
        *ngFor="let item of 'PAGES.Additional.situaciones_comunes_items' | translate; let i = index"
        [id]="'ngb-panel-' + (i + 1)"
        class="mb-4"
      >
        <ng-template ngbPanelHeader>
          <div class="d-flex align-items-center justify-content-between">
            <button ngbPanelToggle class="btn btn-link container-fluid text-left pl-0 py-0">
              <div class="d-inline-flex align-items-center w-sumary">
                <p class="mb-0 Gotham-medium f-15 f-lg-20 text-aditional">{{ item.title }}</p>
              </div>
              <div class="float-right">
                <img
                  *ngIf="acc.isExpanded('ngb-panel-' + (i + 1))"
                  class=""
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1738635417/spv/sites/images/Additional/Icon-arrow-down-additional_ecbhmm.svg"
                  alt="icon-arrow-close"
                />

                <img
                  *ngIf="!acc.isExpanded('ngb-panel-' + (i + 1))"
                  class=""
                  src="https://res.cloudinary.com/pervolare-org/image/upload/v1737567331/spv/sites/images/Additional/Icon-pf_gngtgf.svg"
                  alt="icon-arrow"
                />
              </div>
            </button>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <p class="Gotham-book f-14 f-lg-16 mb-0">{{ item.description }}</p>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>

    <div class="row mt-5 mb-5">
      <div class="col-12 col-md-6">
        <img
          class="img-fluid mx-auto d-flex"
          src="https://res.cloudinary.com/pervolare-org/image/upload/v1731615127/spv/sites/images/Additional/Img_-_Preguntas_hajpog.png"
          alt="¿Aun tienes preguntas?"
          width="317.35"
          height="384.91"
        />
      </div>
      <div class="col-12 col-md-6 d-flex align-items-center">
        <div class="card-faq bg-white mt-4 mt-md-0">
          <p class="Gotham-bold f-20 f-lg-28 mb-0">{{ 'PAGES.Additional.¿Aún tienes preguntas?' | translate }}</p>
          <p class="Gotham-book f-14 f-lg-16 mb-0">
            {{
              'PAGES.Additional.Comunícate directamente con uno de nuestros asesores para brindarte una información más detallada'
                | translate
            }}
          </p>
          <a
            class="text-white btn btn-plans mt-3 text-white Gotham-medium f-15 py-2"
            [href]="'PAGES.Additional.link contactar' | translate : { phone }"
            target="_blank"
            >{{ 'PAGES.Additional.Contactar' | translate }}</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
